import { apiGet } from "../baseApi";
import { setUserData } from "service/mapper";

export const getById = async (id, cancelToken = null) => {
  try {
    const response = await apiGet("_user", {}, id, { cancelToken });
    return { ...response, data: setUserData(response.data) };
  } catch (error) {
    return Promise.reject(error);
  }
};
